/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here. 
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

// Add event listener for the SVG remove button
// document.querySelectorAll('.line-item__price-list-container .line-item__remove-button').forEach(function(svgButton) {
//   svgButton.addEventListener('click', function(e) {
//     e.preventDefault(); // Prevent the default behavior (if necessary)
    
//     // Find the closest .line-item__quantity container
//     var quantityContainer = svgButton.closest('.line-item__content-wrapper');
    
//     // Find the text-based remove button inside this container
//     var textRemoveButton = quantityContainer.querySelector('.line-item__quantity .line-item__remove-button');
    
//     // Trigger a click on the text remove button
//     if (textRemoveButton) {
//       textRemoveButton.click();
//     }
//   });
// });


document.addEventListener("DOMContentLoaded", function () {
  const menuSwiper = document.querySelector(".header-menu-swiper");
  const menuList = document.querySelector(".header-outer-section");

  function checkScroll() {
    if (menuList.scrollWidth > menuList.clientWidth) {
      menuSwiper.classList.add("scrolling");
    } else {
      menuSwiper.classList.remove("scrolling");
    }
  }

  menuList.addEventListener("scroll", checkScroll);
  checkScroll(); // Initial check
});

$(document).ready(function () {  
  function setUniformSliderHeight() {
    var maxHeight = 0;
    
    $('.collection_slider .carousel-cell').each(function () {
      var cellHeight = $(this).outerHeight();
      if (cellHeight > maxHeight) {
        maxHeight = cellHeight;
      }
    });
 
    $('.collection_slider .flickity-viewport').each(function () {
      $(this).height(maxHeight);
    });
  }
 
    // Run on page load
    setUniformSliderHeight();
  
    // Optional: Run on resize
    $(window).resize(function () {
      setUniformSliderHeight();
    });


    HedaerSlider();
    function HedaerSlider() {
      var headerLength = $(".header--transparent").length;
      if (headerLength > 0) {
        $("body , .slideshow__slide-inner").addClass("slide-image-transparent");
      }
    }
    $(window).on("resize", function () {
      HedaerSlider();
    });
  });

$(document).ready(function () {
  // Accordion toggle for footer and product accordion
   $(".product-accordion-main .accordion_head_default").on("click", function (e) {
    e.preventDefault();
    var $this = $(this);

    // Collapse all others if clicked one is not already active
    if (!$this.hasClass("accordion-active")) {
      $(".product-accordion-main .accordion_body_default").slideUp(400);
      $(".product-accordion-main .accordion_head_default").removeClass("accordion-active");
    }

    // Toggle current
    $this.toggleClass("accordion-active");
    $this.next().stop(true, true).slideToggle(400);
  });
  
  $(".mobile-link-accordion").on("click", function (e) {
  // If the click is on an <a>, allow navigation
  if ($(e.target).is("a")) {
    return;
  }

  e.preventDefault();
  var $this = $(this);

  if (!$this.hasClass("accordion-active")) {
    $(".mobile-link-accordion .footer__item-content").slideUp(400);
    $(".mobile-link-accordion").removeClass("accordion-active");
  }

  $this.toggleClass("accordion-active");
  $this.find('.footer__item-content').stop(true, true).slideToggle(400);

});
setTimeout(function () {
  var $label = $(".pl-swatches__label");

  // Text split karo
  var text = $label.text();

  // Example: "Color: Band Grey"
  var parts = text.split(":");

  if (parts.length > 1) {
    var first = parts[0] + ":";       // "Color:"
    var second = parts[1];     // "Band Grey"

    // Remove the word "color" (case-insensitive)
    second = second.replace(/\bcolor\b/ig, "").trim();
    
    // HTML replace with styled spans
    $label.html(
      "<span style='font-weight:700;'>" + first + "</span> " +
      "<span style='font-weight:400;'>" + second + "</span>"
    );
  }
}, 500); // 0.5s delay, adjust if required

  // Payment icon accordion
  $(".product-accordion-main .payment-icon").on("click", function (e) {
    e.preventDefault();
    var $this = $(this);

    if (!$this.hasClass("accordion-active")) {
      $(".product-accordion-main .payment-body").slideUp(400);
      $(".product-accordion-main .payment-icon").removeClass("accordion-active");
    }

    $this.toggleClass("accordion-active");
    $this.next().stop(true, true).slideToggle(400);
  });

// $(".mobile-menu-image-slider").slick({
//   slidesToShow: 2,
//   slidesToScroll: 1,
//   arrows: false,
//   dots: false,
//   infinite: true,
//   swipeToSlide: true 
// });
var $slider = $(".mobile-menu-image-slider");

// check if more than 2 slides
if ($slider.children().length > 2) {
  $slider.slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    infinite: true,
    swipeToSlide: true
  });
}
  
  $(".header__mobile__hamburger").on("click", function () {
    $(".mobile-menu-image-slider").slick("setPosition");
  });

});

  $(".carousel").flickity({
    // options
    cellAlign: "left",
    contain: true,
    pageDots: false,
    groupCells: 1,
    wrapAround: true,
  });
  setTimeout(function () {
    $("product-recommendations .carousel").flickity({
      // options
      cellAlign: "left",
      contain: true,
      pageDots: false,
      groupCells: 1,
      wrapAround: true,
    });
  }, 1000);

  // $(document).on("click", ".product-custom-var .on-click-cart", function () {
  //   var ID = $(this).attr("data-var");
  //   $.ajax({
  //     type: "POST",
  //     url: "/cart/add.js",
  //     data: {
  //       quantity: 1,
  //       id: $(this).attr("data-var"),
  //     },
  //     dataType: "json",
  //     success: function (data) {
  //       $("#mini-cart").load(location.href + " #mini-cart>*", "");
  //       setTimeout(function () {
  //         $("cart-drawer").attr("open", "open");  
  //        setTimeout(function () {
  //           console.log(document.querySelector('.scroller__inner'));
  //           const swiper = new Swiper('.scroller__inner', {
  //             loop: false,
  //             slidesPerView: 3.5,
  //             observer: true,
  //             observeParents: true,
  //             virtualTranslate: true 
  //           });
  //         }, 1000);   
  //       }, 500);
  //     },
  //   });
  // });
$(document).on("click",".on-click-cart",function(e){

  e.preventDefault();
  e.stopImmediatePropagation();

  const btn = $(this);

  if(btn.hasClass("soldout") || btn.hasClass("adding")) return;

  btn.addClass("adding");

  const variantID = btn.attr("data-var");

  $.ajax({
    type:"POST",
    url:"/cart/add.js",
    data:{
      id:variantID,
      quantity:1
    },
    dataType:"json",

    success:function(){

      // refresh cart using theme events (better than .load)
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));

      setTimeout(function(){
        $("cart-drawer").attr("open","open");
      },400);

      $("#mobile-size-drawer").removeClass("active");
      $("#mobile-size-overlay").removeClass("active");

    },

    complete:function(){
      btn.removeClass("adding");
    }

  });

});
// document.addEventListener("click", function(e){

//   const trigger = e.target.closest(".mobile-size-trigger");
//   if(!trigger || window.innerWidth > 768) return;

//   e.preventDefault();

//   const productId = trigger.getAttribute("data-product-id");

//   const source = document.querySelector('.product-custom-var[data-product-id="'+productId+'"]');
//   if(!source) return;

//   const drawer = document.getElementById("mobile-size-drawer");
//   const overlay = document.getElementById("mobile-size-overlay");
//   const content = document.getElementById("mobile-size-content");

//   content.innerHTML = source.innerHTML;

//   drawer.classList.add("active");
//   overlay.classList.add("active");

// });
document.addEventListener("click", function(e){

  const trigger = e.target.closest(".mobile-size-trigger");
  if(!trigger || window.innerWidth > 768) return;

  e.preventDefault();

  const productId = trigger.getAttribute("data-product-id");

  const source = document.querySelector('.product-custom-var[data-product-id="'+productId+'"]');
  if(!source) return;

  const drawer = document.getElementById("mobile-size-drawer");
  const overlay = document.getElementById("mobile-size-overlay");
  const content = document.getElementById("mobile-size-content");

  const inner = drawer.querySelector(".mobile-size-inner");

  inner.classList.remove("single-variant");

  if(trigger.dataset.singleVariant === "true"){
    inner.classList.add("single-variant");
  }

  // existing logic
  content.innerHTML = source.innerHTML;

  drawer.classList.add("active");
  overlay.classList.add("active");

});
document.addEventListener("click", function(e){

  const drawer = document.getElementById("mobile-size-drawer");
  const overlay = document.getElementById("mobile-size-overlay");

  if(
    e.target.id === "mobile-size-overlay" ||
    e.target.closest("#close-mobile-size")
  ){
    drawer.classList.remove("active");
    overlay.classList.remove("active");
  }

});

  setTimeout(function () {
    $(document).on(
      "click",
      "product-recommendations .on-click-cart",
      function () {
        var ID = $(this).attr("data-var");
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: {
            quantity: 1,
            id: $(this).attr("data-var"),
          },
          dataType: "json",
          success: function (data) {
            $("#mini-cart").load(location.href + " #mini-cart>*", "");
            setTimeout(function () {
              $("cart-drawer").attr("open", "open");

              setTimeout(function () {
            console.log(document.querySelector('.scroller__inner'));
            const swiper = new Swiper('.scroller__inner', {
              loop: false,
              slidesPerView: 3.5
            });
          }, 1000);
            }, 500);
          },
        });
      }
    );
  }, 1000);



  // =========== COLLECTION PAGE : MOBILE CUSTOM FILTER BUTTON ===========

  $(".mobile-filter-sort-btn").click(function () {
    // Trigger a click event on Button A
    $(".mobile-toolbar__item.mobile-toolbar__item--filters").click();
  });

  function updateStatus() {
    // Select the element with class 'product__media-item is-selected'
    var originalPosition = $(".product__media-item.is-selected").attr(
      "data-original-position"
    );
    var cellNumber = parseInt(originalPosition, 10) + 1;
    var CountTotal = $(".product__media-list-wrapper").find(
      ".product__media-item"
    ).length;
    if (CountTotal > 1) {
      $(".carousel-status").text(cellNumber + " / " + CountTotal);
    }
  }
  updateStatus();
  $(".mobile-carousel").on("change.flickity", updateStatus);


$(document).ready(function () {

  // Open sidebar
  $(document).on("click", ".open-sidebar", function (e) {
    e.preventDefault();

    let $btn = $(this);

    // Scope correctly: either product form inside .product OR <quick-buy-drawer>
    let $container = $btn.closest(".product .product-form, quick-buy-drawer, quick-buy-popover");

    let $sidebar = $container.find(".product-sidebar");

    if ($sidebar.length) {
      $sidebar.addClass("drawer--is-open").attr("open", true);
      $container.find(".sidebar-overlay").addClass("active");
      $("body").addClass("drawer-open-size");
    }
  });

  // Close sidebar
  $(document).on("click", ".close-sidebar, .drawer__overlay", function () {
    let $btn = $(this);
    let $container = $btn.closest(".product .product-form, quick-buy-drawer, quick-buy-popover");

    $container.find(".product-sidebar").removeClass("drawer--is-open").removeAttr("open");
    $container.find(".sidebar-overlay").removeClass("active");
    $("body").removeClass("drawer-open-size");
  });
  
  // $(".open-sidebar").on("click", function (e) {
  //   e.preventDefault();
  //   $(".product-sidebar")
  //     .addClass("drawer--is-open")
  //     .attr("open", true); // Add the 'open' attribute
  //   $(".sidebar-overlay").addClass("active");
  //   $("body").addClass("drawer-open-size");
  // });

  // $(".close-sidebar, .drawer__overlay").on("click", function () {
  //   $(".product-sidebar")
  //     .removeClass("drawer--is-open")
  //     .removeAttr("open"); // Remove the 'open' attribute
  //   $(".sidebar-overlay").removeClass("active");
  //   $("body").removeClass("drawer-open-size");
  // });
  

function toggleScrollerClass() {
  $('.featured-collections.featured-scrollbar').each(function () {
    const $target = $(this).find('.product-list__inner > div');

    const windowWidth = window.innerWidth;

    if (windowWidth >= 320 && windowWidth <= 999) {
      // Remove classes on small screens
      $target.removeClass('product-list__inner--scroller hide-scrollbar');
    } else if (windowWidth >= 1000) {
      // Add classes back on larger screens
      $target.each(function () {
        const $el = $(this);
        if (!$el.hasClass('product-list__inner--scroller')) {
          $el.addClass('product-list__inner--scroller hide-scrollbar');
        }
      });
    }
  });
}

// Initial call
$(document).ready(toggleScrollerClass);

// Debounced resize handler
$(window).on('resize', function () {
  clearTimeout(window.toggleScrollTimeout);
  window.toggleScrollTimeout = setTimeout(toggleScrollerClass, 100);
});

});


$(document).ready(function () {
  function initSlick() {
    if ($(window).width() > 1000) {
      if (!$('.my-slider').hasClass('slick-initialized')) {
        $('.my-slider').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          responsive: [
            {
              breakpoint: 1400,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2
              }
            }
          ]
        });
      }
    } else {
      if ($('.my-slider').hasClass('slick-initialized')) {
        $('.my-slider').slick('unslick');
      }
    }
  }

  // On load
  initSlick();

  // On resize
  $(window).on('resize', function () {
    initSlick();
  });
});
document.addEventListener("DOMContentLoaded", function () {
  // to enable dots in mobile product media
  var flkty = new Flickity('.product__media-list', {
    // your options
  });

  var dots = document.querySelectorAll('.dots-nav__item');

  // Sync dots on slide change
  flkty.on('change', function(index) {
    dots.forEach(function(dot) {
      dot.removeAttribute('aria-current');
    });

    if (dots[index]) {
      dots[index].setAttribute('aria-current', 'true');
    }

    var status = document.getElementById('slider-index-display');
    if (status) {
      status.textContent = (index + 1) + ' / ' + dots.length;
    }
  });

  // 👉 ADD THIS PART
  dots.forEach(function(dot, index) {
    dot.addEventListener('click', function(e) {
      e.preventDefault(); // optional
      flkty.select(index); // move slider to clicked dot
    });
  });

  handleBISButtonVisibility();
});

// Detect variant change (swatches or dropdown)
document.addEventListener("change", function (e) {
  if (
    e.target.classList.contains("block-swatch__radio") || 
    e.target.closest('select[name="id"]')
  ) {
    setTimeout(() => {
      handleBISButtonVisibility();
    }, 50);
  }
});

function handleBISButtonVisibility() {
  const bisOriginal = document.querySelector(".bis-button.BIS_trigger");
  const bisCustom = document.querySelector("#BIS_trigger_custom");

  if (!bisOriginal || !bisCustom) return;

  // Get original button visibility
  const isOriginalVisible = window.getComputedStyle(bisOriginal).display !== "none";

  if (isOriginalVisible) {
    // Original BIS button is visible → show custom
    bisCustom.style.display = "block";
  } else {
    // Original BIS button is hidden → hide custom button
    bisCustom.style.display = "none";
  }

  // Bind trigger only once
  if (!bisCustom.dataset.bound) {
    bisCustom.addEventListener("click", () => {
      bisOriginal.click();
    });
    bisCustom.dataset.bound = "true";
  }
}
